const getNavigator = (): Navigator | undefined => (typeof navigator !== 'undefined' ? navigator : undefined);

export const isIOS = (): boolean => {
  const nav = getNavigator();
  if (!nav) {
    return false;
  }

  const ua = nav.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || (/Mac/.test(ua) && nav.maxTouchPoints > 1);
};

export const isAndroid = (): boolean => {
  const nav = getNavigator();
  if (!nav) {
    return false;
  }

  return /Android/i.test(nav.userAgent);
};

export const isSafari = (): boolean => {
  const nav = getNavigator();
  if (!nav) {
    return false;
  }

  return /^((?!chrome|android).)*safari/i.test(nav.userAgent);
};
